export enum PARSER_ACTION {
    UNKNOWN = 0,
    UNKNOWN_TOPIC = 1,
    UNKNOWN_ACTION = 2,
    INVALID_MESSAGE = 3,
    MESSAGE_PARSE_ERROR = 4,
    MAXIMUM_MESSAGE_SIZE_EXCEEDED = 5,
    ERROR = 6,
    INVALID_META_PARAMS = 7,
}
